<div class="date_selecteur" style="display: flex; flex-direction: row; align-items: center; margin: 0 20px;" >
  <label class="weight-500">{{label}}&nbsp;</label>
  <button mat-icon-button aria-label="jour précédent" class="success md-48" (click)="variationDate(-1)">
      <mat-icon class="primary noBackground" >arrow_left</mat-icon>
  </button>
  <mat-form-field>
      <!-- <mat-label>Date de livraison</mat-label> -->
      <input
        #dateInput
        matInput
        [matDatepicker]="picker"
        [value]="date"
        (dateChange)="changeDate($event)"
        (focus)="onFocus(dateInput)"
        (mouseup)="onMouseUp($event)"
        (blur)="onBlur()"
      />
      <mat-hint><button mat-button (click)="setToday()" >Aujourd'hui</button></mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <button mat-icon-button aria-label="jour suivant"  (click)="variationDate(1)">
      <mat-icon class="primary noBackground">arrow_right</mat-icon>
  </button>
</div>
@if (calendarOpen) {
  <mat-calendar class="calendar-open" [selected]="shown" [startAt]="shown" (selectedChange)="pickDay($event)"></mat-calendar>
}
